import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LiveAgentSupportService } from '../../header/live-agent-support/live-agent-support.service';
import { LoginService } from '../login.service';

@Component({
  selector: 'lp2-recovery-box',
  templateUrl: './recovery-box.component.html',
  styleUrls: ['./recovery-box.component.scss']
})
export class RecoveryBoxComponent {
  isLoading: boolean;
  email: string;
  resetSuccess: boolean;
  submitted: boolean;
  isCheckingB2G = false;
  b2gMessageKey: string;

  @ViewChild('chatOnline') chatOnline: ElementRef;
  @ViewChild('b2gModalTemplate') b2gModalTemplate: ElementRef;

  b2gModalSettings: NgbModalOptions = {
    backdrop: 'static',
    centered: true,
  };

  constructor(
    private loginService: LoginService,
    private liveAgentSupportService: LiveAgentSupportService,
    private modalService: NgbModal,
  ) {}

  enterLiveChat() {
    this.liveAgentSupportService.startChat();
  }

  resetPassword() {
    this.isCheckingB2G = true;
    this.loginService.checkB2GLogin(this.email).subscribe(
      (res) => {
        this.isCheckingB2G = false;
        if (res.messageKey) {
          this.b2gMessageKey = res.messageKey;
          this.modalService.open(this.b2gModalTemplate, this.b2gModalSettings);
          return;
        }
        this.proceedWithPasswordReset();
      },
      () => {
        this.isCheckingB2G = false;
        this.proceedWithPasswordReset();
      }
    );
  }

  private proceedWithPasswordReset() {
    this.isLoading = true;
    this.submitted = false;

    this.loginService.resetPasswordWithEmail(this.email).subscribe(
      (res) => this.handleResetPasswordSuccess(res),
      (error) => this.handleResetPasswordError(error)
    );
  }

  private handleResetPasswordSuccess(res: any) {
    this.isLoading = false;
    this.submitted = true;
    this.resetSuccess = true;
  }

  private handleResetPasswordError(error: any) {
    console.error(error);
    this.isLoading = false;
    this.submitted = true;
    this.resetSuccess = false;
  }
}



// WEBPACK FOOTER //
// ./ts/app/login/recovery-box/recovery-box.component.ts